import axios from 'axios'
import { API_BASE, apiErrorHandler } from '../api'
import Auth from '@/services/auth'
import UserEvent from '../userEvents/models'

const VERIFYEMPLOYEEID = `${API_BASE}employee-codes/verify-employee-code/`
const UPLOAD_EMPLOYEE_CODES_CSV_ENDPOINT = `${API_BASE}employee-codes/upload-csv/`
const DRY_UPLOAD_EMPLOYEE_CODES_CSV_ENDPOINT = `${API_BASE}employee-codes/dry-upload-csv/`
const CONFIRM_FILE_FEED_ENDPOINT = `${API_BASE}employee-codes/confirm-file-feed-upload/`
const CANCEL_FILE_FEED_ENDPOINT = `${API_BASE}employee-codes/cancel-file-feed-upload/`
const CURRENT_ELIGIBILTY_LIST = `${API_BASE}employee-codes/current-list/`

export default class EmployeeCodeAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new EmployeeCodeAPI(cls)
  }

  async verifyEmployeeId(id) {
    const data = { code: id }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    // update the user event with the attempts
    // we don't care about errors here
    const userEventsRequest = await UserEvent.api.employeeCodeVerificationAttempts()

    // attempt to verify
    // all errors from this point for verification
    const employeeVerificationRequest = axios.post(VERIFYEMPLOYEEID, data, options)

    return (
      employeeVerificationRequest
        .then(values => {
          return this.cls.fromAPI(values.data)
        })
        // Disable 400 alert - the UI will parse the error message and display its own message
        .catch(err => {
          return apiErrorHandler({ apiName: 'Employee Verification error', enable400Alert: false })(
            err,
          )
        })
    )
  }

  uploadCSV(file, { isStaff, organization, subOrganizationId }) {
    let data = new FormData()
    data.append('file', file)
    if (isStaff) {
      data.append('organization', organization)
    }

    if (subOrganizationId) {
      data.append('sub_organization_id', subOrganizationId)
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios.post(UPLOAD_EMPLOYEE_CODES_CSV_ENDPOINT, data, options).catch(
      apiErrorHandler({
        apiName: 'Employee Codes API (uploadCSV) error',
      }),
    )
    return promise
  }

  dryUploadCSV(file, { isStaff, organization, subOrganizationId }) {
    let data = new FormData()
    data.append('file', file)
    if (isStaff) {
      data.append('organization', organization)
    }

    if (subOrganizationId) {
      data.append('sub_organization_id', subOrganizationId)
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios.post(DRY_UPLOAD_EMPLOYEE_CODES_CSV_ENDPOINT, data, options).catch(
      apiErrorHandler({
        apiName: 'Employee Codes API (dryUploadCSV) error',
      }),
    )
    return promise
  }

  confirmFileFeedUpload(fileFeedUploadId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const data = { employee_code_import_id: fileFeedUploadId }
    const promise = axios.post(CONFIRM_FILE_FEED_ENDPOINT, data, options).catch(
      apiErrorHandler({
        apiName: 'Employee Codes API (confirmFileFeedUpload) error',
      }),
    )
    return promise
  }

  cancelFileFeedUpload(fileFeedUploadId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const data = { employee_code_import_id: fileFeedUploadId }
    const promise = axios.post(CANCEL_FILE_FEED_ENDPOINT, data, options).catch(
      apiErrorHandler({
        apiName: 'Employee Codes API (cancelFileFeedUpload) error',
      }),
    )
    return promise
  }

  getCurrentEligibilityList(organizationId, subOrganizationId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const data = { organization_id: organizationId, sub_organization_id: subOrganizationId }
    const promise = axios
      .post(CURRENT_ELIGIBILTY_LIST, data, options)
      .then(response => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        let file_name = `current_list_${new Date().toUTCString()}`
        link.setAttribute('download', file_name + '.csv')
        link.click()
      })
      .catch(
        apiErrorHandler({
          apiName: 'Employee Codes API (cancelFileFeedUpload) error',
        }),
      )
    return promise
  }
}
